import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { WebsiteRelatedProgramsComponent } from './website-related-programs.component'
import { SharedModule } from '../shared/shared.module'
import { RichsnipetService } from 'dmmp-services'
import { NgxJsonLdModule } from 'ngx-json-ld'

@NgModule({
  imports: [CommonModule, SharedModule, NgxJsonLdModule],
  declarations: [WebsiteRelatedProgramsComponent],
  exports: [WebsiteRelatedProgramsComponent],
  providers: [RichsnipetService],
})
export class WebsiteRelatedProgramsModule {}
